/* unplugin-vue-components disabled */
import {FileUpload} from 'stores/files'

export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    instance: {
      type: FileUpload,
      required: true,
    }
  },
  emits: ['delete'],
  computed: {
    file () {
      return this.instance.file
    },
    ext () { 
      return this.file.name.split('.').pop()
    },
    size () {
      return $utils.format.bytes(+this.instance.file.size)
    },
    progress () {
      return Math.floor(this.instance.bytes_loaded / this.instance.file.size * 100)
    },
    error() {
      return this.instance.error
    },
    error_detail() {
      return this.instance.error_detail
    },
    success() {
      return this.instance.result !== undefined
    }
  }
}
